@if (employeeContract()) {
  <mat-card
    @enterFadeIn
    class="qaroni-card-bg-background mat-elevation-z0 h-full pb-2">
    <mat-card-content class="flex w-full flex-col gap-2">
      <div class="mt-1 w-full">
        <span class="qaroni-detail-title" i18n>Contrato</span>
      </div>
      <mat-divider class="my-3" />
      <div class="grid w-full grid-cols-2 gap-3">
        @if (employeeContract()?.educationLevel) {
          <div class="col-span-2 md:col-span-1">
            <qaroni-label-text-preview
              label="Nivel de educación"
              [value]="
                employeeContract()?.educationLevel | employeeEducation
              " />
          </div>
        }
        @if (employeeContract()?.grossSalary) {
          <div class="col-span-2 md:col-span-1">
            <qaroni-label-text-preview
              label="Salario anual"
              [value]="
                (employeeContract()?.paymentInfoJson?.type
                  | paymentMethodSymbol) +
                ' ' +
                employeeContract()?.grossSalary
              " />
          </div>
        }
        @if (employeeContract()?.contractCode) {
          <div class="col-span-2 md:col-span-1">
            <qaroni-label-text-preview
              label="Código de contrato"
              [value]="employeeContract()?.contractCode" />
          </div>
        }
        @if (employeeContract()?.ccc) {
          <div class="col-span-2 md:col-span-1">
            <qaroni-label-text-preview
              label="Código de cuenta de cotización"
              [value]="employeeContract()?.ccc" />
          </div>
        }
        @if (employeeContract()?.ssn) {
          <div class="col-span-2 md:col-span-1">
            <qaroni-label-text-preview
              label="Número de seguridad social"
              [value]="employeeContract()?.ssn" />
          </div>
        }
        @if (employeeContract()?.iban) {
          <div class="col-span-2 md:col-span-1">
            <qaroni-label-text-preview
              label="IBAN"
              [value]="employeeContract()?.iban" />
          </div>
        }
        @if (employeeContract()?.vacationDays) {
          <div class="col-span-2 md:col-span-1">
            <qaroni-label-text-preview
              label="Días de vacaciones"
              [value]="employeeContract()?.vacationDays" />
          </div>
        }
        @if (employeeContract()?.jobPosition) {
          <div class="col-span-2 md:col-span-1">
            <qaroni-label-text-preview
              label="Cargo"
              [value]="employeeContract()?.jobPosition" />
          </div>
        }
        @if (employeeContract()?.type) {
          <div class="col-span-2 md:col-span-1">
            <qaroni-label-text-preview
              label="Tipo de contrato"
              [value]="employeeContract()?.type | employeeContract" />
          </div>
        }
        @if (employeeContract()?.journeyScale) {
          <div class="col-span-2 md:col-span-1">
            <qaroni-label-text-preview
              label="Tipo de jornada"
              [value]="
                employeeContract()?.journeyScale | employeeJourneyScale
              " />
          </div>
        }
        @if (employeeContract()?.journeyHours) {
          <div class="col-span-2 md:col-span-1">
            <qaroni-label-text-preview
              label="Horas de la jornada"
              [value]="employeeContract()?.journeyHours" />
          </div>
        }
        @if (employeeContract()?.start) {
          <div class="col-span-2 md:col-span-1">
            <qaroni-label-text-preview
              label="Inicio de contrato"
              [value]="employeeContract()?.start" />
          </div>
        }
        @if (employeeContract()?.end) {
          <div class="col-span-2 md:col-span-1">
            <qaroni-label-text-preview
              label="Fin de contrato"
              [value]="employeeContract()?.end" />
          </div>
        }
        @if (employeeContract()?.isOnTest) {
          <div class="col-span-2 md:col-span-1">
            <qaroni-label-text-preview
              label="Se encuentra a prueba"
              [value]="employeeContract()?.isOnTest | boolean" />
          </div>
        }
        @if (employeeContract()?.testPeriodFinish) {
          <div class="col-span-2 md:col-span-1">
            <qaroni-label-text-preview
              label="Fin de prueba"
              [value]="employeeContract()?.testPeriodFinish" />
          </div>
        }
      </div>
    </mat-card-content>
  </mat-card>
}
